// extracted by mini-css-extract-plugin
module.exports = {"location":"log_location_1wbPo"};